function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * MDX default components
 */
var DEFAULTS = {
  inlineCode: 'code',
  wrapper: 'div'
};
/**
 * Renders final tag/component
 * @param {Vue.Component|String} type Element or tag to render
 * @param {Object|Array} props Props and attributes for element
 * @param {Array} children Array of child nodes for component
 * @returns {Vue.VNode} VNode of final rendered element
 */

function createElement (type, props, children) {
  var h = this.createElement;
  var components = this.components;
  var defaults = Object.keys(DEFAULTS);
  var tag;
  var elProps = props; // We check context to see if the element/tag
  // is provided in the MDXProvider context.

  if (Object.keys(components).includes(type)) {
    // We check to see if props is of type object.
    // If it is, then we pass them into the MDXContext component
    var componentProps = _typeof(props) === 'object' ? props : undefined;
    tag = components[type](componentProps);
  } else if (defaults.includes(type)) {
    tag = DEFAULTS[type]; // Remove components object from attrs

    var _elProps$attrs = elProps.attrs,
        _components = _elProps$attrs.components,
        attrs = _objectWithoutProperties(_elProps$attrs, ["components"]);

    elProps = {
      attrs: attrs
    }; // Render final tag if component is not provided in context
  } else {
    tag = type;

    if (['a', 'input', 'img'].includes(tag)) {
      var _elProps = elProps,
          _attrs = _elProps.attrs,
          domProps = _objectWithoutProperties(_elProps, ["attrs"]);

      var data = {
        attrs: _attrs,
        domProps: domProps
      };
      elProps = _objectSpread2(_objectSpread2({}, elProps), data);
    }
  }

  return h(tag, elProps, children);
}

/**
 * MDXProvider component
 *
 * This component custom components from the user and
 * provides them to the context tree for all output markdown.
 *
 */
var MDXProvider = {
  name: 'MDXProvider',
  props: {
    components: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  provide: function provide() {
    var _this = this;

    return {
      $mdxComponents: function $mdxComponents() {
        return _this.components;
      }
    };
  },
  render: function render(h) {
    return h('div', this.$slots["default"]);
  }
};

export { MDXProvider, createElement as mdx };
